module.exports = __webpack_public_path__ + "a09156172eef4b4fdfd0d37ffa70d689.png";